/**
 * Options for the duration a workkard is shared between organizations.
 * @constant {Array<{Id: number, Name: string, Description: string, CreatedBy: number, CreatedDate: string}>}
 */
export const SHARE_DURATION_OPTIONS = [
  {
    Id: 4,
    Name: 'Always',
    Description: 'Always',
    CreatedBy: 56,
    CreatedDate: '2021-09-21T06:03:55.319508',
  },
  {
    Id: 1,
    Name: 'Till the related activities are closed',
    Description: '',
    CreatedBy: 56,
    CreatedDate: '2015-10-15T04:18:54.753',
  },
  {
    Id: 2,
    Name: 'Till the workkard is closed',
    Description: '',
    CreatedBy: 56,
    CreatedDate: '2015-10-15T04:18:54.78',
  },
];

/**
 * Maps relationship statuses to specific UI tags (CSS classes and display text).
 * @constant {Object}
 */
export const B2B_STATUS_TAGS = {
  PENDING_FROM_RECEIVER: {
    className: 'label-ntf label-Responce',
    text: 'Your request has not been responded to',
  },
  PENDING_TO_ACCEPT: { className: 'msg_con pending', text: 'PENDING' },
  IGNORED: { className: 'msg_con ignored', text: 'IGNORED' },
  IGNORED_BY_RECIEVER: { className: 'msg_con ignored', text: 'IGNORED' },
  EXCLUDED: { className: 'label-ntf label-Excluded', text: 'EXCLUDED' },
};

/**
 * Configuration for relationship badges.
 * Provides the appropriate CSS class for each status state.
 * @constant {Object}
 */
export const BADGE_CONFIG = {
  PENDING: {
    className: 'status__pending status__pending__filled',
  },
  PENDING_FROM_RECEIVER: {
    className: 'status__pending status__pending__filled',
  },
  PENDING_TO_ACCEPT: {
    className: 'status__response-awaited status__response-awaited__filled',
  },
  IGNORED: { className: 'status__ignored status__ignored__filled' },
  IGNORED_BY_RECIEVER: { className: 'msg_con ignored' },
  EXCLUDED: { className: 'status__excluded status__excluded__filled' },
  EXCLUDED_SEARCH: { className: 'status__excluded status__excluded__filled' },
  ACCEPTED: { className: 'status__accepted status__accepted__filled' },
  EXCLUDED_PENDING: { className: 'status__excluded status__excluded__filled' },
};

/**
 * Available filters for the relationships list view.
 * @constant {Array<string>}
 */
export const STATUS_FILTERS = ['All', 'Accepted', 'Response Awaited', 'Pending', 'Ignored', 'Excluded'];

/**
 * Maps UI action button labels to their corresponding target API status values.
 * @constant {Object}
 */
export const RELATIONSHIP_ACTION_STATUS = {
  'Send Request': 'PENDING',
  Exclude: 'EXCLUDED_PENDING',
  Include: 'PENDING',
  'De-associate': 'DEASSOCIATE',
  Accept: 'ACCEPTED',
  Ignore: 'IGNORED',
};

/**
 * Maps raw backend status strings to user-friendly text for display.
 * @constant {Object}
 */
export const STATUS_TEXT_MAP = {
  'PENDING_TO_ACCEPT': 'Response Awaited',
  'PENDING_FROM_RECEIVER': 'Pending',
  'EXCLUDED': 'Excluded',
  'EXCLUDED_PENDING': 'Excluded',
  'PENDING': 'Pending',
  'IGNORED': 'Ignored',
  'IGNORED_BY_RECIEVER': 'Ignored',
  'ACCEPTED': 'Accepted',
};
